import { render } from "./Vmenu.vue?vue&type=template&id=480c0359&scoped=true"
import script from "./Vmenu.vue?vue&type=script&lang=js"
export * from "./Vmenu.vue?vue&type=script&lang=js"

import "./Vmenu.vue?vue&type=style&index=0&id=480c0359&scoped=true&lang=css"

import exportComponent from "C:\\TK\\LivppyLab\\LivppyLab\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-480c0359"]])

export default __exports__